import { apiClient } from './client';

export const openBrowserApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        openBrowser: builder.mutation<void, { url: string }>({
            query: ({ url }) => ({
                url: '/api/openBrowser',
                method: 'POST',
                body: { url },
            }),
        }),
    }),
});

export const { useOpenBrowserMutation } = openBrowserApi;
